import { Document, FeedItemLog } from '../../models'

export interface DocumentResponse {
    Key: string,
    Value: {
        Key: string
        Source: Document
        WhyDoISeeThisItem?:string
        log?: {
            dateTime: string,
            description: string,
            type: string
            userName: string
            userTag: null
            userUid: string
        }
    }
}

//DO NOT USE THIS FUNCTION https://app.tuqqi.com/search?searchquery=%23AXBYK3idx1gPQ_ng2hAG
export const constructDocumentDataFromDto = (documentResponse: DocumentResponse): Document => {
    return {
        ...documentResponse.Value.Source,
        docId: documentResponse.Key,
    }
}

export const constructFeedLogs = (documentResponse: DocumentResponse): FeedItemLog[] => {
    const log = documentResponse.Value.log
    const dtoLog = !log || !log.dateTime || !log.description || !log.userUid ? null : {
        dateTime: log.dateTime ?? '',
        description: log.description ?? '',
        type: log.type ?? '',
        userName: log.userName ?? '',
        userUid: log.userUid ?? ''
    }
    return !!dtoLog ? [dtoLog] : []
}